module.exports = __webpack_public_path__ + "static/media/perksIcon12.6ade0abf.svg";